import $ from "jquery";
$(".hamburger").on("click", function () {
  $("#site-container").addClass("nav-expand");
});
$(".hamburger-close").on("click", function () {
  $("#site-container").removeClass("nav-expand");
});
